const formatBool = (val?: number | null) => {
  if (val === 1) return "Yes";
  if (val === 0) return "No";
  return "N/A";
};

export default formatBool;
